import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Header from "./Header";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { IconButton, Tooltip } from "@mui/material";

// Move styled components outside the functional component
const StyledAppLayout = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.toggle ? "12.5rem" : "0rem")} 1fr;
  grid-template-rows: auto 1fr;
  height: 100vh;
  transition: grid-template-columns 0.3s ease-in-out;
`;

const Main = styled.main`
  background-color: ${(props) =>
    props.mode === "dark" ? "#101418" : "#e4eadc"};
  padding: 4.5rem 1rem 2rem;
  overflow: auto;
  transition: background-color 0.3s ease-in-out;
`;

const StyleDiv = styled.div`
  background-color: #3d4f58;
  overflow: auto;
  grid-row: 1/-1;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  transition: all 0.3s;
  z-index: 3000;
  transition: opacity 0.3s ease-in-out;
`;

const IconButtonWrapper = styled.div`
  position: fixed;
  top: 16px;
  left: ${(props) => (props.toggle ? "150px" : "16px")};
  z-index: 20000;
  transition: left 0.3s ease-in-out;
`;

export default function AppLayout() {
  const mode = useSelector((state) => state.mode); // Use mode directly from Redux
  const [toggle, setToggle] = useState(true);

  useEffect(() => {
    // Any side effects related to mode can go here
  }, [mode]);

  return (
    <StyledAppLayout toggle={toggle}>
      <IconButtonWrapper toggle={toggle}>
        <Tooltip title='toggle drawer'>
          <IconButton
            style={{ backgroundColor: "#ccc", borderRadius: "10px" }}
            size='small'
            onClick={() => setToggle(!toggle)}>
            {toggle ? <ArrowLeftIcon /> : <ArrowRightIcon />}
          </IconButton>
        </Tooltip>
      </IconButtonWrapper>

      <Header />
      {toggle ? <SideBar /> : <StyleDiv></StyleDiv>}

      <Main mode={mode}>
        <Outlet />
      </Main>
    </StyledAppLayout>
  );
}
